import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Button from "@Components/Button";
import { auth, signOut } from "@Firebase/firebase";

import { CurrentUser } from "../../App";
import styles from "./Auth.module.scss";
import { useVerifyEmail } from "@Hooks/useVerifyEmail";

const VerifyEmail = ({ currentUser }: { currentUser: CurrentUser }) => {
  const navigate = useNavigate();
  const { sendVerifyEmail } = useVerifyEmail();
  useEffect(() => {
    const interval = setInterval(() => {
      currentUser?.reload();
      auth?.currentUser?.getIdToken(true);
      navigate("/dashboard");
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  const handleSendVerifyEmail = () => {
    sendVerifyEmail({ firebaseUser: currentUser });
  };
  return (
    <div style={{ maxWidth: "450px" }}>
      <h1>Please verify email to log in!</h1>
      <Button
        variant="blue"
        className={styles.authButton}
        type="submit"
        onClick={handleSendVerifyEmail}
        style={{ fontSize: "30px", marginTop: "10px" }}
      >
        Re-send email
      </Button>
      <a href="/" className={styles.signOut} onClick={() => signOut(undefined)}>
        Sign out
      </a>
    </div>
  );
};

export default VerifyEmail;
